// extracted by mini-css-extract-plugin
export default {"switch":"ThemeSwitch_switch__LMnmf","slider":"ThemeSwitch_slider__cIg1q"};